import type {BodyMeasurements} from '../types/body-measurements.ts';

export const bodyMeasurements: BodyMeasurements = {
    id: null,
    userId: '',
    name: 'szb-profile-no-name',
    skinType: 0,
    footShape: null,
    gender: '',
    age: 0,
    is3dFeel: true,
    weight: '',
    height: '',
    measures: {
        insoleLength: 0,
        poundWeight: null,
    },
    product: null,
    isMetric: false,
    bodyShapeChest: 0,
    bodyShapeHip: 0,
    bodyShapeWaist: 0,
};